import './productSelectedTile.scss'
import { cn } from '@quickmd-llc/design-system'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { SecondaryButton } from 'ui_kit_qmd'
import successIcon from '../../../../../../images/common/success-filled.svg'
import pauseIcon from '../../../../../../images/common/pause.svg' // NEW
import { type CartItem } from '../../../../../../types/products/productTypes'
import { useProductOrderContext } from '../../../../context'
import { pluralize } from '@quickmd-llc/frontend-utils'

interface Props {
  onChange: () => void
  isDirty?: boolean
  item: CartItem
}

export const ProductSelectedTile = ({ onChange, isDirty = false, item }: Props) => {
  const { isMoudPharmacyPickup, isMoudHomeDelivery, isMHTHomeDelivery } = useProductOrderContext()
  const { Order: order } = item
  // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
  const title = isMoudHomeDelivery ? order.Name : `${order.Name} - ${order.DurationDisplay}`
  const refillsText = item.RefillsQuantity ? `${item.RefillsQuantity} Refills` : 'No refills'

  const iconSrc = isDirty ? pauseIcon : successIcon
  const iconAlt = isDirty ? 'Paused icon' : 'Order icon'

  const priceClass = isDirty ? 'price-dirty' : ''
  const dosageQuantity = item.DosageQuantity
  const durationText = item.DurationDays ? ` x${item.DurationDays} days` : ''

  return (
    <div className={cn('product-selected-tile-container', isDirty && 'disabled-state')}>
      <div className='product-selected-tile-info-container'>
        <img className='product-selected-tile-success-icon' src={iconSrc} alt={iconAlt} />

        <div className='product-selected-tile-info'>
          <div className='product-selected-tile-text bold'>
            {/*
             // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered */}
            {isMoudHomeDelivery ? title : `${title} (${order.ShortName})`}
          </div>
          <div className='product-selected-tile-subtext duration'>
            {isMoudPharmacyPickup ?
              // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
              `${dosageQuantity ?? 0} ${pluralize(order.DispenseUnits, dosageQuantity ?? 0)}${durationText}`
            // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
            : `${order.DurationDisplay} - ${refillsText}`}
          </div>
          {/*
           // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered */}
          {order.Price ?
            // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
            <div className={`product-selected-tile-text price-text ${priceClass}`}>${order.Price.toFixed(2)}</div>
          : null}
        </div>
      </div>

      {!isMHTHomeDelivery && (
        <SecondaryButton
          useUpdatedStyle
          btnText='Edit'
          containerStyle={{ width: 107, height: 40 }}
          onPress={onChange}
        />
      )}
    </div>
  )
}
